import { createAction } from 'lib/store-utils';
import { ServerUserFields } from 'type';
import { SetListPayload, SetOrDeleteOnePayload } from './types';

export const BOX_USERS_COLLECTION_SET_LIST = createAction<SetListPayload>('Users collection / set list');
export const BOX_USERS_COLLECTION_USER_CHANGED = createAction<ServerUserFields>('Users collection / user changed');
export const BOX_USERS_COLLECTION_SET_OR_DELETE_ONE = createAction<SetOrDeleteOnePayload>('Users / set or delete one');
